import React, { useState } from "react";
import { AHSeparator, Dialog, FilterButton, ListItem } from "arkh";
import { RoleFilter } from "./filter";
import { FormattedMessage, useIntl } from "react-intl";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";
import { ScrollView } from "react-native";

type Role = { readonly id: string; readonly name: string };

export function FilterButtonRole(props: {
  selectedRole: RoleFilter;
  setSelectedRole: (role: RoleFilter) => void;
  roles: readonly Role[];
}) {
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();

  const withoutRoleLabel = intl.formatMessage({
    defaultMessage: "Without role",
    description:
      "TeamScheduleAdmin role filter option for routines without any assigned role",
  });

  const selectedRoleName =
    props.selectedRole === "without-role"
      ? withoutRoleLabel
      : (props.roles.find((r) => r.id === props.selectedRole)?.name ?? "");

  const isActive = props.selectedRole !== "all";

  const onSelect = (value: RoleFilter) => {
    onPressInHaptic();
    if (props.selectedRole === value) {
      props.setSelectedRole("all");
    } else {
      props.setSelectedRole(value);
    }
  };

  const allOptions: { value: RoleFilter; label: string }[] = [
    { value: "without-role", label: withoutRoleLabel },
    ...props.roles.map((r) => ({ value: r.id as RoleFilter, label: r.name })),
  ];

  const label = isActive ? (
    selectedRoleName
  ) : (
    <FormattedMessage
      defaultMessage="Role"
      description="TeamScheduleAdmin filter button label for role filter"
    />
  );

  return (
    <>
      {isActive ? (
        <FilterButton
          mode="active"
          isPlural={true}
          indicatorIcon="user"
          onPress={() => setIsOpen(true)}
        >
          {label}
        </FilterButton>
      ) : (
        <FilterButton
          mode="inactive"
          indicatorIcon="user"
          onPress={() => setIsOpen(true)}
        >
          {label}
        </FilterButton>
      )}
      <Dialog
        visible={isOpen}
        onClose={() => setIsOpen(false)}
        title={
          <FormattedMessage
            defaultMessage="Role"
            description="TeamScheduleAdmin role filter dialog title"
          />
        }
      >
        <ScrollView style={{ flex: 1 }}>
          {allOptions.map((option, index) => {
            const selected = props.selectedRole === option.value;
            return (
              <React.Fragment key={option.value}>
                {index > 0 ? <AHSeparator /> : null}
                <ListItem
                  right={<ListItem.SelectIndicator selected={selected} />}
                  onPress={() => onSelect(option.value)}
                >
                  <ListItem.Title
                    color={selected ? "text-primary" : "text-secondary"}
                  >
                    {option.label}
                  </ListItem.Title>
                </ListItem>
              </React.Fragment>
            );
          })}
        </ScrollView>
      </Dialog>
    </>
  );
}
